import * as React from 'react';
import { deprecatedComponent } from '../react/components/core/deprecated-component.js';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
/**
 * @deprecated
 * use <Icon iconType="" /> instead
 **/ const IconFilePsd = deprecatedComponent({
    displayName: 'IconFilePsd',
    // @ts-ignore
    root: (props)=>/*#__PURE__*/ React.createElement("svg", _object_spread({
            viewBox: "0 0 32 40",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            width: "1em",
            height: "1em"
        }, props), /*#__PURE__*/ React.createElement("path", {
            d: "M31 15V35C31 37.2091 29.2091 39 27 39H5C2.79086 39 1 37.2091 1 35V5C1 2.79086 2.79086 1 5 1H17",
            stroke: "black",
            strokeWidth: 1.5,
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }), /*#__PURE__*/ React.createElement("path", {
            d: "M17 15V1L31 15H17Z",
            stroke: "black",
            strokeWidth: 1.5,
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }), /*#__PURE__*/ React.createElement("path", {
            d: "M8.64 26.4795H6V34.2395H7.76V31.4395H8.72C10.48 31.4395 11.6 30.6395 11.6 29.0395V28.9595C11.6 27.2795 10.48 26.4795 8.64 26.4795ZM9.92 28.9595C9.92 29.7595 9.44 30.1595 8.64 30.1595H7.68V27.7595H8.56C9.44 27.8395 9.92 28.1595 9.92 28.9595Z",
            fill: "black"
        }), /*#__PURE__*/ React.createElement("path", {
            d: "M15.5202 29.5211C14.3202 29.3611 14.0802 29.1211 14.0802 28.5611C14.0802 28.0811 14.4802 27.6811 15.2002 27.6811C15.9202 27.6811 16.4002 28.0011 16.4802 28.7211H18.0802C17.9202 27.2011 16.9602 26.4011 15.2002 26.4011C13.5202 26.4011 12.4002 27.3611 12.4002 28.7211C12.4002 30.2411 13.2002 30.8011 15.2002 31.0411C16.3202 31.2011 16.6402 31.4411 16.6402 32.0811C16.6402 32.7211 16.1602 33.1211 15.3602 33.1211C14.2402 33.1211 13.9202 32.5611 13.8402 31.8411H12.1602C12.2402 33.3611 13.2002 34.4011 15.3602 34.4011C17.2002 34.4011 18.3202 33.2811 18.3202 31.9211C18.3202 30.2411 17.3602 29.7611 15.5202 29.5211Z",
            fill: "black"
        }), /*#__PURE__*/ React.createElement("path", {
            d: "M22.0795 26.4795H19.5195V34.2395H21.9995C24.7195 34.2395 26.0795 32.7195 26.0795 30.3995V30.3195C26.1595 27.9195 24.7995 26.4795 22.0795 26.4795ZM24.3195 30.3995C24.3195 31.9995 23.5995 32.8795 21.9995 32.8795H21.2795V27.8395H21.9995C23.5995 27.8395 24.3195 28.7195 24.3195 30.3195V30.3995Z",
            fill: "black"
        })),
    description: 'The Inline SVG Icon API is deprecated, use the Icon component instead'
});

export { IconFilePsd };
